import {Routes} from '@angular/router';
import {authGuard} from "./core/guard/auth.guard";
import {roleGuard} from "./core/guard/role.guard";
import {UserRole} from "./utils/enum";

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./pages/login-page/login-page').then(m => m.LoginPage),
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./pages/dashboard-page/dashboard-page').then(m => m.DashboardPage),
    },
    {
        path: 'profile',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./pages/profile-page/profile-page').then(m => m.ProfilePage),
    },
    {
        path: 'organizations',
        canActivate: [authGuard, roleGuard],
        data: {roles: [UserRole.SUPERADMIN]},
        loadComponent: () =>
            import('./pages/organizations-page/organizations-page').then(m => m.OrganizationsPage),
    },
    {
        path: 'users',
        canActivate: [authGuard, roleGuard],
        data: {roles: [UserRole.SUPERADMIN, UserRole.ADMIN]},
        loadComponent: () =>
            import('./pages/user-page/user-page').then(m => m.UserPage),
    },
    {
        path: 'customers',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./pages/customers-page/customers-page').then(m => m.CustomersPage),
    },
    {
        path: 'contracts',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./pages/contracts-page/contracts-page').then(m => m.ContractsPage),
    },
    {
        path: 'task-orders',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./pages/task-order-page/task-order-page').then(m => m.TaskOrderPage),
    },
    {
        path: 'imports',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./pages/import-page/import-page').then(m => m.ImportPage),
    },
    {
        path: 'reports',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./pages/report-page/report-page').then(m => m.ReportPage),
    },
    {
        path: 'not-found',
        loadComponent: () =>
            import('./pages/not-found-page/not-found-page').then(m => m.NotFoundPage),
    },
    {
        path: '**',
        redirectTo: 'not-found',
    },
];
